import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BusinessServices from '../components/BusinessServices';
import businessCareerImg from '../assets/icons/business-career.webp';
// Hero import removed (not used on this page)

const BusinessCareerPage = () => {
  useEffect(() => {
    // Ensure the page is at the top when navigated to (fixes mobile deep-linking scroll position)
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      // fallback
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <div className="business-career-page">
      <Navigation />

      {/* Use the site Hero styling so page headers match the home page */}
  <section className="bg-sand pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="font-serif text-5xl lg:text-6xl mb-6 text-indigoDeep">
              <img src={businessCareerImg} alt="Business & Career" className="page-header-icon" />
              Business & Career
            </h1>
            <p className="text-xl text-grayWarm max-w-3xl mx-auto leading-relaxed">
              Align your growth with precise timing and opportunity windows. Let astrology reveal when to launch,
              how to lead, and who to partner with for success.
            </p>
          </div>
        </div>
      </section>

  <div className="py-16 bg-sand">
        <div className="max-w-7xl mx-auto px-6">
          <BusinessServices />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BusinessCareerPage;
